import { useMsal } from '@azure/msal-react';

export const useSalutation = () => {
  const { accounts } = useMsal();

  const name = accounts?.[0]?.name || '';
  const firstName = (name.split(',').map((part) => part.trim())[1] || '').split(' ')[0] || '';
  const hours = new Date().getHours();
  const salutation = `Good ${hours < 12 ? 'morning' : hours > 17 ? 'evening' : 'afternoon'}, `;
  return { salutation, firstName };
};
